import { useMutation } from "@tanstack/react-query";
import { punchJobAction } from "../actions/punchEventJob.actions";

export const useJobPunch = (jobEventUid: string) => {
  const token = sessionStorage.getItem("token") ?? "";

  const startMutation = useMutation({
    mutationFn: () =>
      punchJobAction({ jobEventUid, action: "start" }, token),
  });

  const endMutation = useMutation({
    mutationFn: () =>
      punchJobAction({ jobEventUid, action: "end" }, token),
  });

  return {
    startJob: startMutation.mutateAsync,
    isStarting: startMutation.isPending,

    endJob: endMutation.mutateAsync,
    isEnding: endMutation.isPending,
  };
};
